export class GroupPaymentType {
    id?: number;
    title?: string;
    description?: string;

    static fromJson(fields: any): GroupPaymentType {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
